import React, { useEffect, useState } from "react";
import "./Nav.css";
import {
  Badge,
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Modal,
  Nav,
  Offcanvas,
  Row,
} from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { FaBell } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "./SidebarData";
import DeleteModel from "../../components/DeleteModel";
import logo from "../../assets/images/logo.png";
import { Menu } from "antd";
import { clearAllLocalStorage } from "../../constants/localStorage";
import { LogOut } from "lucide-react";
const { SubMenu } = Menu;
const MainNav = () => {
  const { color } = "#ffffff";
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [newNotifications, setNewNotifications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [viewedNotifications, setViewedNotifications] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState({});

  const handleClose = () => setShow(false);
  const handleNavigateAddForm = () => setShow(true);
  const handleModelClose = () => setLogoutShow(false);

  const handleLogout = () => {
    clearAllLocalStorage();
    navigate("/");
    window.location.reload();
  };

  const handleCloseNotifications = () => {
    setShowNotifications(false);
    setSelectedNotification(null);
    setNewNotifications([]);
  };

  const handleShowAllNotifications = () => {
    navigate("/admin/notification");
    handleCloseNotifications();
  };

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id;
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(sidebarItems, location.pathname);
  return (
    <>
      <Container
        fluid
        className="d-flex flex-row flex-wrap-wrap justify-content-between align-items-center overflowX-hidden"
        style={{
          position: "sticky",
          top: "0",
          zIndex: 1000,
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #e9edf4",
        }}
      >
        <Row className="d-flex flex-row flex-wrap-wrap justify-content-around align-items-center p-2">
          <Col className="d-lg-none d-xl-none d-sm-flex">
            <AiOutlineMenu
              size={25}
              onClick={handleNavigateAddForm}
              className="pointer"
              color="#515b73"
            />
          </Col>
          <Col
            className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-between align-items-center"
            style={{ marginRight: "100px" }}
          >
            <img
              src={logo}
              width={45}
              className="pointer rounded-circle"
              alt="MainLogoImage1"
              title="MainLogoImage1"
            />
          </Col>
        </Row>
        {/* mobile view */}

        <Row>
          <Col className='d-lg-none d-sm-flex flex-row flex-wrap-wrap justify-content-between" align-items-center'>
            <img
              src={logo}
              width={50}
              className="p-2 pointer rounded-circle"
              alt="MainLogoImage2"
              title="MainLogoImage2"
            />
          </Col>
        </Row>

        <Row className="d-flex mt-1">
          <Col className="d-lg-none d-sm-flex">
            <div className="d-flex align-items-center position-relative">
              {newNotifications.length > 0 ? (
                <Dropdown>
                  <Dropdown.Toggle
                    className="mobile-view-dropdown"
                    id="dropdown-basic"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#515b73",
                    }}
                  >
                    <div className="notification-bell">
                      <FaBell
                        size={20}
                        style={{
                          cursor: "pointer",
                          color: "#515b73",
                          marginRight: "0px",
                        }}
                      />
                      {newNotifications.length > 0 && (
                        <Badge
                          pill
                          bg="danger"
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            fontSize: "10px",
                          }}
                        >
                          {newNotifications.length}
                        </Badge>
                      )}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Header>
                      <h5 style={{ fontWeight: "bold", color: color }}>
                        Notifications
                      </h5>
                    </Dropdown.Header>
                    {/* {notificationData && notificationData.data && (
                      <>
                        {notificationData.data.length > 0 ? (
                          notificationData.data
                            .slice(0, 3)
                            .map((notification) => (
                              <Dropdown.Item
                                className="boxShadow"
                                key={notification._id}
                                onClick={() =>
                                  handleNotificationClick(notification)
                                }
                              >
                                <div className="notification-item mx-3  m-1">
                                  <h6>
                                    {truncateText(notification.title, 20)}
                                  </h6>
                                  <p className="text-wrap">
                                    {truncateText(notification.subtitle, 20)}
                                  </p>
                                </div>
                              </Dropdown.Item>
                            ))
                        ) : (
                          <Dropdown.Item>No notifications</Dropdown.Item>
                        )}
                        <Dropdown.Divider />
                        <Dropdown.Item
                          onClick={handleShowAllNotifications}
                          className="text-center"
                          style={{ color: color }}
                        >
                          See All Notifications
                        </Dropdown.Item>
                      </>
                    )} */}
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <FaBell
                  size={20}
                  style={{
                    cursor: "pointer",
                    color: "#515b73",
                    marginRight: "0px",
                  }}
                  onClick={handleShowAllNotifications}
                />
              )}

              <Dropdown>
                <Dropdown.Toggle
                  className="mobile-view-dropdown"
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#515b73",
                  }}
                >
                  <BsThreeDotsVertical
                    size={25}
                    style={{ cursor: "pointer", color: "#515b73" }}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item></Dropdown.Item>
                  <Dropdown.Item onClick={() => setLogoutShow(true)}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>

          {/* lap view */}
          <Col className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-center align-items-center position-relative">
            <div className="d-flex align-items-center position-relative">
              {newNotifications.length > 0 ? (
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-notifications"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#515b73",
                    }}
                  >
                    <div className="notification-bell">
                      <FaBell
                        size={20}
                        style={{
                          cursor: "pointer",
                          color: "#515b73",
                          marginRight: "0px",
                        }}
                      />
                      {newNotifications.length > 0 && (
                        <Badge
                          pill
                          bg="danger"
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            fontSize: "10px",
                          }}
                        >
                          {newNotifications.length}
                        </Badge>
                      )}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Header>
                      <h5 style={{ fontWeight: "bold", color: color }}>
                        Notifications
                      </h5>
                    </Dropdown.Header>
                    {/* {notificationData && notificationData.data && (
                      <>
                        {notificationData.data.length > 0 ? (
                          notificationData.data
                            .slice(0, 3)
                            .map((notification) => (
                              <Dropdown.Item
                                key={notification._id}
                                onClick={() =>
                                  handleNotificationClick(notification)
                                }
                              >
                                <div className="m-3">
                                  <h6>{notification.title}</h6>
                                  <p className="text-wrap">
                                    {truncateText(notification.subtitle, 50)}
                                  </p>
                                </div>
                              </Dropdown.Item>
                            ))
                        ) : (
                          <Dropdown.Item>No notifications</Dropdown.Item>
                        )}
                        <Dropdown.Divider />
                        <Dropdown.Item
                          onClick={handleShowAllNotifications}
                          className="text-center "
                          style={{ color: color }}
                        >
                          See All Notifications
                        </Dropdown.Item>
                      </>
                    )} */}
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <FaBell
                  size={20}
                  style={{
                    cursor: "pointer",
                    color: "#515b73",
                    marginRight: "0px",
                  }}
                  onClick={handleShowAllNotifications}
                />
              )}

              <MdEmail
                size={20}
                style={{
                  cursor: "pointer",
                  color: "#515b73",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
                onClick={() => navigate("/admin/email")}
              />

              <Dropdown>
                <Dropdown.Toggle
                  color="#515b73"
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#515b73",
                  }}
                >
                  <img
                    src="https://p7.hiclipart.com/preview/636/702/321/computer-icons-user-profile-avatar-black-man.jpg"
                    className="rounded-circle"
                    style={{ width: "30px" }}
                    alt="Avatar"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setLogoutShow(true)}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Conditionally render Offcanvas for large screens */}
      <Row className="d-none d-lg-flex d-xl-flex d-xxl-flex">
        <Offcanvas scroll={false} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{ backgroundColor: color }} closeButton>
            <Offcanvas.Title
              className="custom-title"
              style={{
                fontSize: "16px",
                color: "#515b73",
              }}
            >
              <img
                src={logo}
                width={50}
                className="rounded-circle p-2"
                alt="image"
              />
              School Management
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: " #FFFFFF" }}>
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{ height: "100%", borderRight: 0 }}
              theme="light"
            >
              {sidebarItems.map((menu) =>
                menu.children && menu.children.length > 0 ? (
                  <SubMenu
                    key={menu.id}
                    icon={<menu.icon />}
                    style={{
                      color: selectedKey === menu.id ? "#5b77e6" : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id ? "#f2f5ff" : "#ffffff",
                    }}
                    title={
                      <span style={{ color: "#6d758a" }}>{menu.label}</span>
                    }
                  >
                    {menu.children.map((item) => (
                      <Menu.Item
                        key={item.id}
                        icon={item.icon}
                        style={{
                          color:
                            selectedKey === item.id ? "#5b77e6" : "#6d758a",
                          backgroundColor:
                            selectedKey === item.id ? "#f2f5ff" : "#ffffff",
                        }}
                      >
                        <Link
                          onClick={handleClose}
                          className="link-unstyled"
                          to={item.url}
                        >
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item
                    key={menu.id}
                    icon={<menu.icon />}
                    style={{
                      color: selectedKey === menu.id ? "#5b77e6" : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id ? "#f2f5ff" : "#ffffff",
                    }}
                  >
                    <Link
                      onClick={handleClose}
                      className="link-unstyled"
                      to={menu.url}
                    >
                      {menu.label}
                    </Link>
                  </Menu.Item>
                )
              )}
            </Menu>
          </Offcanvas.Body>
          <div
            style={{
              padding: "15px",
              backgroundColor: "#f7f7f7",
              textAlign: "center",
              borderTop: "1px solid #ddd",
            }}
          >
            <Nav.Link
              className="d-flex flex-column align-items-center p-2"
              href="/logout"
            >
              <LogOut size={24} className="text-secondary" />
              <span
                className="text-secondary mt-1"
                style={{ fontSize: "0.7rem" }}
              >
                Logout
              </span>
            </Nav.Link>
          </div>
        </Offcanvas>
      </Row>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Do You Want To Logout"
        DELETETITLE="Logout"
      />

      {/* notification modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Notification Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedNotification &&
          selectedNotification.orderDetails.length > 0 ? (
            selectedNotification.orderDetails.map((detail, index) => (
              <div key={index}>
                {Object.entries(detail).map(
                  ([key, value]) =>
                    key !== "_id" &&
                    key !== "products" && (
                      <Form.Group key={key} className="mb-3">
                        <Form.Label>
                          <strong>{key}</strong>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          readOnly
                          disabled
                          value={value}
                        />
                      </Form.Group>
                    )
                )}
                <hr />
              </div>
            ))
          ) : (
            <h5 className="text-center mt-3 mb-3">
              Notification Details is empty..
            </h5>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MainNav;
